<script>
  import { onMount } from 'svelte';
  import { format_date } from '../../lib/utils.js';
  import { t9n } from '../../lib/translate.js';
  import HistoryMachine from '../history-machine.js';
  import SimplePaginator from '../../lib/workpilots-ui/SimplePaginator.svelte';
  import moment from 'moment';


  export let id;
  export let main;
  export let context;

  let test_comments = ["",
                       "let value_field\n"
                     + "var machine = new HistoryMachine({id, main, context})\n"
                     + "context = machine.context",
                       "Comment comment comment comment com ent e co mente\n" +
                     + "CommComment comment comment comment com ent e co mente",
                       "ent comment comment comment com ent e co mente",
                       "",]

  let value_field;
  let machine = new HistoryMachine({id, main, context});
  context = machine.context;

  $:{
    machine.update_context(context);
    context = machine.context;
  };

  const get_random_comment = () => {
    return test_comments[Math.floor(Math.random()*test_comments.length)]
  }

  const get_history = async (page=1, num=10) => {
    await machine.get_history(page, num);
    context = machine.context;
  }

  const init = async () => {
    await get_history();
  };

  // todo: hover needs to add to height or set height to auto

  onMount(async () => {
    await init();
  });
</script>


<style>
  .mdc-data-table-bold {
    background-color: blanchedalmond;
  }

  .mdc-data-table__table {
    white-space: break-spaces;
    /*overflow-wrap: break-word;*/
    border-collapse: collapse;
  }

  .mdc-data-table__cell, .mdc-data-table__header-cell {
    padding-right: 10px;
    padding-left: 10px;
  }

  td {
    /*white-space: -o-pre-wrap;*/
    /*word-wrap: break-word;*/
    /*white-space: pre-wrap;*/
    /*white-space: -moz-pre-wrap;*/
    /*white-space: -pre-wrap;*/
    /*max-width: 190px;*/
    color: #4a4a4a;
  }

  td > div {
    /*height: 20px;*/
    /*overflow: hidden;*/
    max-height: 20px;
    transition: max-height 1s ease-out;
    overflow: hidden;
  }

  tr:hover > td > div {
    /*height: auto;*/
    /*transition: height 2s;*/
    max-height: 500px;
    transition: max-height 2s ease-in;
  }


  .table-head.numeric {
    text-align: left;
    width: 12%;
  }

  .table-head.comment {
    width: 25%;
  }

  .table-head.type {
    width: 10%;
  }

  .table-head.date {
    width: 12%;
  }

  .table-cell.text {
    text-align: left;
    /*word-wrap: break-word;*/
    /*overflow-wrap: break-word;*/
    width: 25%;
    max-width: 9em;
  }

  .no-pp {
    white-space: nowrap;
    font-size: .875rem;
    letter-spacing: -0.0178571429em;
    font-weight: 800;
    color: #616161;
    vertical-align: middle;
    display: table-cell;
    height: 80px;
    padding-left: 20px;
  }
</style>


<div class="pilotpoints-history"
     on:ppbuy={init}
     on:ppdonate={init}
     on:ppclaim={init}>

<div style="margin-top: 30px"></div>
  <div class="mdc-data-table table-min-height fade-in" style="display: flex;">
      <table class="mdc-data-table__table">
        <thead>
        <tr class="mdc-data-table__header-row mdc-data-table-bold">
          <th class="mdc-data-table__header-cell table-head date">{context.date_label}</th>
          <th class="mdc-data-table__header-cell table-head type">{context.type_label}</th>
          <th class="mdc-data-table__header-cell table-head numeric">{context.pp_label}</th>
          <th class="mdc-data-table__header-cell table-head numeric">{context.price_label}</th>
          <th class="mdc-data-table__header-cell table-head comment">{context.transaction_label}</th>
          <th class="mdc-data-table__header-cell table-head comment">{context.comment_label}</th>
        </tr>
        </thead>
        <tbody>
        {#if context.items}
          {#if context.items.length > 0}
            {#each context.items as item}
              <tr class="mdc-data-table__row">
                <td class="mdc-data-table__cell table-head date"><div>{format_date(item.date, false)}</div></td>
                <td class="mdc-data-table__cell table-head type"><div>{t9n(item.type)}</div></td>
                <td class="mdc-data-table__cell table-head numeric"><div>{item.pilot_points}</div></td>
                <td class="mdc-data-table__cell table-head numeric"><div>{(item.pilot_points / context.multiplier).toFixed(2)} {context.currency_sign}</div></td>
                <td class="mdc-data-table__cell table-cell text"><div>{@html machine.get_item_data(item)}</div></td>
<!--                <td class="mdc-data-table__cell table-cell text"><div>{get_random_comment()}</div></td>-->
                <td class="mdc-data-table__cell table-cell text"><div>{item.comment || ''}</div></td>
              </tr>
            {/each}
          {:else}
              <p class="no-pp">{context.no_pp}</p>
          {/if}
        {/if}
        </tbody>
      </table>
  </div>
  <div>
    <SimplePaginator get_page_data_fn={get_history}
                       paging_data={context.paging_data}/>
  </div>
</div> <!-- end of fieldset History -->
